import React from 'react'
import { articleService } from '../../services/article.service'
import queryString from 'query-string'
import dynamic from 'next/dynamic';
import { serverLocationDetector } from '../../utils/locationDetector';
import BreadcumbLinks from '../../components/Common/BreadcumbLinks';
const Layout = dynamic(() => import('../../components/_App/Layout'))
const ArticlesList = dynamic(() => import('../../templates/Articles'))

export default function knowledge({ articles, categories, activeSearch, activeTag, isAppleMobile, page }){

    const [fullsearch, setFullsearch] = React.useState('') 

    return (
        <Layout
            isAppleMobile = {isAppleMobile}
            seo={{
                description: `Weedzly Library - Learn About Cannabis. ${page ? ' Page '+page : ''}`,
                image: '/static/icons/favicon.png',
                title: `${page ? 'Page '+page+' - ' : ''}Discover cannabis information including new terms, beginner friendly guides and different ways to consume.`,
                url:'https://weedzly.com/library'
            }}
        >
            <ArticlesList 
                items={articles} 
                categories={categories}
                fullsearch={fullsearch}
                setFullsearch={setFullsearch}
                activeSearch={activeSearch}
                activeTag={activeTag}
                link={`/library`}
                linkAs={`/library`}
            />
        </Layout>
    )
}

export async function getServerSideProps(context){
    
    let isAppleMobile = (context.req
        ? context.req.headers['user-agent']
        : navigator.userAgent).match(
          /iPhone|iPad|iPod/i
        )
        await serverLocationDetector(context)

    let contextQuery = context.query
    
            console.log(contextQuery);
    
    let fullsearch = contextQuery.fullsearch 
    let activeSearch = context.query.search || null
    let newQuery = Object.assign({page:1, size:12}, contextQuery)
    let activeTag = Object.keys(contextQuery).map((i => contextQuery[i]))[0] || null
    const {articles, categories} = await articleService.getMainPage(`?${queryString.stringify(newQuery)}&sortField=createdAt&sortOrder=desc`)

    return {
        props: { 
            page: (context.query && context.query.page) ? context.query.page : null,
            articles, 
            categories, 
            activeSearch, 
            activeTag, 
            isAppleMobile 
        }
    } 
}